import { render } from "./UserProfileCard.vue?vue&type=template&id=050b514f&scoped=true"
import script from "./UserProfileCard.vue?vue&type=script&lang=js"
export * from "./UserProfileCard.vue?vue&type=script&lang=js"

import "./UserProfileCard.vue?vue&type=style&index=0&id=050b514f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050b514f"]])

export default __exports__